import React, { useContext } from "react";
import Navbar from "./select-components/navbar-select";
import PageHeader from "./global-components/page-header";
import SearchListSection from "./section-components/search-list";
import Footer from "./select-components/footer-select";
import EmpresaContext from "../context";
import { Helmet } from "react-helmet";

const SearchList = ({ initialState, locationKey }) => {
  let context = useContext(EmpresaContext);
  return (
    <div>
      <Helmet title={"Busca de imóveis"} />
      <Navbar />
      <PageHeader
        backgroundImage={
          context.info_gen["image-header-pages"] ||
          context.banner[1] ||
          context.banner[0]
        }
        headertitle="Buscar imóveis"
        subheader="Busca de imóveis"
      />
      <SearchListSection
        initialState={
          initialState || {
            estado_uf: null,
            cidade_id: null,
            empreendimento_id: null,
            bairro: null,
            uf_nome: {},
            loading_ufs: true,
            preço_min_venda: 0,
            preço_max_venda: 0,
            preço_min_locacao: 0,
            preço_max_locacao: 0,
            transacao: "ambas"
          }
        }
        locationKey={locationKey}
      />
      <Footer />
    </div>
  );
};

export default SearchList;
